import React from "react";
import Reveal from "./ui/Reveal";
import MagneticButton from "./ui/MagneticButton";
import PawField from "./ui/PawField";

const WHATSAPP_URL =
  "https://wa.me/5516997502577?text=Ol%C3%A1%2C%20quero%20come%C3%A7ar%20a%20usar%20o%20PawSuite.";

const DEMO_URL = process.env.REACT_APP_APP_URL || "https://demo.pawsuite.com.br";

const CallToAction = () => (
  <section className="relative overflow-hidden bg-softIvory px-6 py-24">
    <div className="relative mx-auto max-w-6xl">
      <Reveal variant="scale">
        <div className="grain relative overflow-hidden rounded-[44px] bg-gradient-to-br from-midnight via-deepNavy to-abyss px-8 py-20 text-center shadow-[0_60px_120px_-40px_rgba(15,31,61,.6)] sm:px-14">
          <PawField count={9} tone="rgba(255,255,255,.05)" />

          <div
            className="aurora-blob animate-drift"
            style={{
              top: "-30%",
              left: "10%",
              width: "45%",
              height: "120%",
              background:
                "radial-gradient(circle,rgba(0,178,169,.4),transparent 65%)",
            }}
          />
          <div
            className="aurora-blob animate-drift"
            style={{
              bottom: "-40%",
              right: "5%",
              width: "45%",
              height: "120%",
              background:
                "radial-gradient(circle,rgba(244,163,64,.32),transparent 65%)",
              animationDelay: "-12s",
            }}
          />

          <div className="relative">
            <h2 className="mx-auto mb-6 max-w-3xl font-display text-[clamp(2rem,5vw,3.6rem)] font-extrabold leading-[1.06] text-white">
              Seu pet shop merece
              <br className="hidden sm:block" />{" "}
              <span className="text-gradient">uma tarde mais leve</span>
            </h2>

            <p className="mx-auto mb-12 max-w-xl text-lg leading-relaxed text-white/55">
              Comece hoje e organize agenda, prontuário e caixa antes do próximo
              banho entrar pela porta.
            </p>

            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
              <MagneticButton
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group rounded-2xl bg-tealVitality px-9 py-4 text-lg font-bold text-white shadow-glow transition-shadow duration-300 hover:shadow-[0_0_0_1px_rgba(0,178,169,.35),0_30px_70px_-15px_rgba(0,178,169,.6)]"
              >
                Falar no WhatsApp
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.38-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.42-.07-.13-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2z" />
                </svg>
              </MagneticButton>

              <MagneticButton
                href={DEMO_URL}
                strength={0.2}
                className="rounded-2xl border border-white/15 bg-white/[.06] px-9 py-4 text-lg font-bold text-white backdrop-blur-md transition-colors duration-300 hover:bg-white/[.12]"
              >
                Explorar a demo
              </MagneticButton>
            </div>

            <p className="mt-8 text-sm text-white/35">
              Sem cartão de crédito · Sem taxa de instalação · Resposta em minutos
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CallToAction;
